import { useState } from 'react';
import { Outlet, createRoute, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from './__root.js';
import { TopBar } from '../components/layout/TopBar.js';
import { Sidebar } from '../components/layout/Sidebar.js';
import { MobileNavDrawer } from '../components/layout/MobileNavDrawer.js';
import { SuspendedScreen } from '../components/SuspendedScreen.js';
import { ReactivateScreen } from '../components/billing/BillingGate.js';
import { PastDueBanner } from '../components/billing/PastDueBanner.js';
import { useAuthStore } from '../lib/auth.js';
import { useSuspensionStore } from '../lib/suspension.js';
import { useBillingBlockStore } from '../lib/billing-block.js';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/app',
  beforeLoad: () => {
    const state = useAuthStore.getState();
    if (!state.accessToken || !state.user) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const suspended = useSuspensionStore((s) => s.suspended);
  const billingBlocked = useBillingBlockStore((s) => s.blocked);

  // A suspended agency is blocked server-side (403 on every request); replace the
  // whole app with the suspended screen. Super-admins never trip this.
  // Suspension takes precedence over a billing block.
  if (suspended) return <SuspendedScreen />;

  // A billing-lapsed agency (402 on every feature route) gets the subscribe
  // screen. Both flags clear on the next successful request (e.g. once they
  // subscribe, or a super-admin grants a trial/comp).
  if (billingBlocked) return <ReactivateScreen />;

  return (
    <div className="min-h-screen flex flex-col">
      <TopBar onMenu={() => setNavOpen(true)} />
      <MobileNavDrawer open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex-1 flex">
        <Sidebar />
        <main className="flex-1 min-w-0 px-4 sm:px-6 lg:px-10 py-6 sm:py-8 max-w-app">
          <PastDueBanner />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
